export default "__VITE_ASSET__Dd4fl0gA__"